var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _polygon, _g, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs2, _path22, _path23, _path24, _polygon2, _path25, _polygon3, _path26, _path27, _path28, _polygon4, _polygon5, _path29, _g3, _circle2, _circle3, _ellipse, _path30, _circle4, _circle5, _ellipse2, _path31, _path32, _circle6, _circle7, _ellipse3, _g4, _path33, _circle8, _ellipse4, _path34, _g5, _g6, _defs3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_3_);}\n\t.st1{fill:#05324A;}\n\t.st2{fill:#101429;}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#9ED9F8;}\n\t.st5{opacity:0.44;fill:url(#SVGID_5_);}\n\t.st6{fill:#12348D;}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:#9043C3;stroke:#9043C3;stroke-miterlimit:10;}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{clip-path:url(#SVGID_9_);fill:#12348D;}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:url(#SVGID_14_);}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{fill:#5F3DAE;}\n\t.st18{fill:url(#SVGID_16_);}\n\t.st19{fill:url(#SVGID_17_);}\n\t.st20{fill:none;stroke:#FFFFFF;stroke-width:0.3193;stroke-miterlimit:10;}\n\t.st21{fill:#FFFFFF;}\n\t.st22{fill:url(#SVGID_18_);}\n\t.st23{fill:url(#SVGID_19_);}\n\t.st24{fill:url(#SVGID_20_);}\n\t.st25{fill:url(#SVGID_21_);}\n\t.st26{fill:none;stroke:#FFFFFF;stroke-width:0.4103;stroke-miterlimit:10;}\n\t.st27{fill:url(#SVGID_22_);}\n\t.st28{fill:url(#SVGID_23_);}\n\t.st29{fill:#E50054;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.2
    },
    width: 510,
    height: 705,
    xlinkHref: "9FB9073D.png",
    transform: "matrix(0.24 0 0 0.24 18.36 -2.52)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M84.3,84.5c1.6,0.6,2.9,0.8,3.6,0l-3.1-1.1l-1.5,0.7L84.3,84.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.6989,
    y1: 75,
    x2: 112.3922,
    y2: 75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005573"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2358,
    style: {
      stopColor: "#005877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4836,
    style: {
      stopColor: "#006184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    style: {
      stopColor: "#007099"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#0084B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0085B7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.6,5.5h48.9c6.6,0,11.9,5.3,11.9,11.9v115.1c0,6.6-5.3,11.9-11.9,11.9H48.6c-6.6,0-8.9-5.3-8.9-11.9 V95.2V45.7V17.5C39.7,10.9,45,5.5,51.6,5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.6,143.2c-6.3,0-7.7-5.8-7.7-10.6V17.5c0-5.9,4.8-10.6,10.6-10.6h48.9c5.9,0,10.6,4.8,10.6,10.6v115.1 c0,5.9-4.8,10.6-10.6,10.6H48.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.5,12.5h13.7c0.3,0,0.5,0.3,0.5,0.7c0,0.4-0.2,0.7-0.5,0.7H68.5c-0.3,0-0.5-0.3-0.5-0.7 C68,12.9,68.3,12.5,68.5,12.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.8755,
    y1: 11.3607,
    x2: 39.4747,
    y2: 153.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2ECFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1552,
    style: {
      stopColor: "#CEEAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#C1E3F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4851,
    style: {
      stopColor: "#ACD7EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6545,
    style: {
      stopColor: "#8FC7E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#69B2D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9966,
    style: {
      stopColor: "#3B99C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3A98C6"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.6,8.4h-4.7l-4.6,5.6c-1.1,1.4-2.8,2.2-4.5,2.2H66.5c-1.8,0-3.4-0.8-4.5-2.2l-4.6-5.6h-4.7 c-5.6,0-10.2,4.7-10.2,10.4v112.3c0,4.7,1.3,10.4,7.4,10.4h49.8c5.6,0,10.2-4.7,10.2-10.4V18.8C109.8,13.1,105.2,8.4,99.6,8.4z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.9,58.3c0,20.3-0.1,36.8-0.1,36.8s-0.1-16.5-0.1-36.8s0.1-36.8,0.1-36.8S111.9,37.9,111.9,58.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.4,58.3c0,20.3-0.1,36.8-0.1,36.8c-0.1,0-0.1-16.5-0.1-36.8s0.1-36.8,0.1-36.8 C40.4,21.4,40.4,37.9,40.4,58.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.4,6.2c-11.5,0-20.8-0.1-20.8-0.1s9.3-0.1,20.8-0.1c11.5,0,20.8,0.1,20.8,0.1S87.9,6.2,76.4,6.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 84.6,
    cy: 13.2,
    r: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.8685,
    y1: 83.371,
    x2: 133.6205,
    y2: 60.2568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.5,5.5H58.8l47.8,137.2c3.5-2.1,5.8-5.9,5.8-10.2V17.5C112.4,10.9,107.1,5.5,100.5,5.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.4,143.9c-11.5,0-20.8-0.1-20.8-0.1c0-0.1,9.3-0.1,20.8-0.1c11.5,0,20.8,0.1,20.8,0.1 C96.3,143.9,86.9,143.9,75.4,143.9z"
  })))), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.4,85.5c-0.4,0-0.8-0.1-1-0.4c-0.3-0.2-0.4-0.6-0.4-1c0-0.4,0.1-0.7,0.4-1c0.3-0.2,0.6-0.4,1-0.4 s0.8,0.1,1,0.4c0.3,0.2,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1C67.2,85.4,66.8,85.5,66.4,85.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.7307,
    y1: 62.5317,
    x2: 71.6005,
    y2: 62.5317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9134,
    style: {
      stopColor: "#040F57"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "61.7,60.4 68.3,57.9 71.6,66.7 70.4,67.2 70.1,66.7 70.9,66.4 68.1,58.7 62.5,60.7 62.7,61.4  62.2,61.6  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 62.3,
    y1: 64.5,
    x2: 66.1,
    y2: 63.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 62.5,
    y1: 65.1,
    x2: 66.3,
    y2: 63.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 62.8,
    y1: 65.7,
    x2: 66.6,
    y2: 64.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 63,
    y1: 66.4,
    x2: 66.8,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 63.4,
    y1: 67.1,
    x2: 67.3,
    y2: 65.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 63.7,
    y1: 67.8,
    x2: 67.4,
    y2: 66.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 63.9,
    y1: 68.3,
    x2: 67.8,
    y2: 66.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 64.2,
    y1: 69,
    x2: 67.9,
    y2: 67.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 64.2,
    y1: 69.7,
    x2: 66.2,
    y2: 69
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M66.4,85.5c-0.4,0-0.8-0.1-1-0.4c-0.3-0.2-0.4-0.6-0.4-1s0.1-0.7,0.4-1c0.3-0.2,0.6-0.4,1-0.4 c0.4,0,0.8,0.1,1,0.4c0.3,0.2,0.4,0.6,0.4,1s-0.1,0.7-0.4,1C67.2,85.4,66.8,85.5,66.4,85.5z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.9,94.4c-0.6,0-1.3-0.1-2-0.4c-0.7-0.2-1.3-0.6-1.8-1.1l1.5-1.8c0.4,0.3,0.7,0.5,1.2,0.7 c0.4,0.2,0.8,0.3,1.2,0.3c0.4,0,0.7-0.1,0.9-0.2c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2-0.1-0.4-0.4-0.5c-0.2-0.1-0.6-0.3-1-0.4 l-1.2-0.5c-0.5-0.2-1-0.6-1.4-1c-0.4-0.5-0.6-1.1-0.6-1.8c0-0.6,0.2-1.1,0.5-1.6c0.3-0.5,0.8-0.8,1.3-1.1 c0.6-0.3,1.2-0.4,1.9-0.4c0.6,0,1.2,0.1,1.7,0.3c0.6,0.2,1.1,0.6,1.6,1L53.2,87c-0.3-0.2-0.7-0.4-1-0.5c-0.3-0.1-0.7-0.2-1-0.2 c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.2,0.1,0.4,0.4,0.5c0.3,0.1,0.6,0.3,1.1,0.5l1.2,0.5 c0.6,0.2,1.1,0.6,1.4,1c0.3,0.4,0.5,1,0.5,1.7c0,0.6-0.2,1.1-0.5,1.6c-0.3,0.5-0.7,0.9-1.3,1.2C52.5,94.2,51.7,94.4,50.9,94.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M56.2,94.2V83.5h2.6v5.7h0.1l2.1-2.7h2.9l-2.7,3.2l2.9,4.5h-2.9l-1.5-2.7l-0.8,0.9v1.8H56.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.0925,
    y1: 90.3259,
    x2: 67.738,
    y2: 90.3259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD2B48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C03249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    style: {
      stopColor: "#E79556"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BD2B48"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M65.1,94.2v-7.7h2.6v7.7H65.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M71.7,94.4c-0.6,0-1.1-0.1-1.4-0.4c-0.3-0.2-0.6-0.6-0.7-1c-0.1-0.4-0.2-0.9-0.2-1.5v-8H72v8.1 c0,0.3,0,0.4,0.1,0.5c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0.3,1.9c-0.1,0.1-0.3,0.1-0.5,0.2 C72.3,94.3,72,94.4,71.7,94.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M76.3,94.4c-0.6,0-1.1-0.1-1.4-0.4c-0.3-0.2-0.6-0.6-0.7-1C74,92.5,74,92,74,91.5v-8h2.6v8.1 c0,0.3,0,0.4,0.1,0.5c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0.3,1.9c-0.1,0.1-0.3,0.1-0.5,0.2 C76.9,94.3,76.6,94.4,76.3,94.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83,86.4c0.6,0,1.1,0.1,1.4,0.3c0.4,0.2,0.6,0.4,0.8,0.7c0.2-0.4,0.5-0.6,0.8-0.8c0.3-0.2,0.7-0.3,1.2-0.3 c0.3,0,0.6,0.1,1,0.2s0.6,0.4,0.8,0.7c0.1-0.2,0.2-0.4,0.4-0.5c0.2-0.1,0.4-0.2,0.7-0.2h1.3c0.2,0,0.3,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3h-1.5v6.4c0,0-0.1,0-0.3,0.1c-0.2,0-0.3,0-0.5,0 c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.1-0.5v-4.5c-0.1-0.3-0.2-0.6-0.4-0.8 c-0.2-0.2-0.5-0.3-0.8-0.3s-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 c0.1,0,0.2,0,0.3,0c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3,0,0.4c0,0.3-0.1,0.6-0.3,0.7c-0.2,0.2-0.5,0.2-0.8,0.2 c-0.3,0-0.6-0.1-0.8-0.2c-0.3-0.2-0.5-0.4-0.6-0.7c-0.1,0.3-0.3,0.5-0.6,0.7c-0.3,0.2-0.6,0.3-1,0.3c-0.3,0-0.6-0.1-0.8-0.3 c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.1,0,0.3,0.1,0.6,0.1c0.3,0,0.5-0.1,0.7-0.2 c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.5-0.3-0.9-0.3h-0.8c-0.2,0-0.3-0.1-0.5-0.2 c-0.1-0.1-0.2-0.3-0.2-0.6c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3H83z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M97.4,94.4c-0.4-0.3-0.9-0.6-1.2-0.9c-0.4-0.3-0.8-0.5-1.2-0.7c-0.4-0.2-0.8-0.4-1.3-0.6 c-0.4-0.2-0.9-0.4-1.4-0.6c-0.1-0.1-0.1-0.3-0.2-0.5c0-0.2-0.1-0.5-0.1-0.7c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2,0.1-0.3l0.7-0.1 c0.6-0.1,1-0.3,1.2-0.5c0.2-0.2,0.3-0.4,0.3-0.6c0-0.1,0-0.2-0.1-0.4c-0.2,0.1-0.5,0.3-0.7,0.3c-0.3,0.1-0.5,0.1-0.8,0.1 c-0.5,0-1-0.1-1.3-0.4c-0.3-0.3-0.5-0.6-0.5-1c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.7-0.3c0.2,0,0.4,0,0.5,0.1 c0,0.3,0.1,0.5,0.2,0.6c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.3,0,0.4-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.2,0.4-0.3 c0.1-0.1,0.3-0.2,0.5-0.3c0.2,0.1,0.3,0.3,0.5,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.2,0.4,0.3,0.7c0.1,0.2,0.1,0.5,0.1,0.7 c0,0.6-0.2,1-0.5,1.4c-0.3,0.4-0.8,0.6-1.4,0.8c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.4,0.2,0.6,0.4 c0.2,0.1,0.4,0.2,0.6,0.3c0-0.2,0-0.4,0-0.7c0-0.2,0-0.5,0-0.6v-3.1c0-0.4,0.1-0.7,0.3-0.9c0.2-0.3,0.5-0.4,0.9-0.4h1.7 c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3h-1.5v6.3c-0.1,0.1-0.2,0.2-0.4,0.2 c-0.2,0.1-0.4,0.1-0.7,0.1c-0.1,0-0.1,0-0.2,0C97.5,94.4,97.4,94.4,97.4,94.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.7,93.4v1.5c0,0.3,0,0.6,0,0.8c0,0.2-0.1,0.4-0.1,0.5l0.7,0.5c0.4,0.3,0.7,0.6,0.9,0.8 c0.2,0.3,0.3,0.5,0.3,0.8c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0.1-0.3,0.1-0.6,0.1 c-0.3-0.4-0.5-0.7-0.8-1c-0.2-0.3-0.4-0.5-0.6-0.8c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.7,0.2-1.1,0.2c-0.3,0-0.5,0-0.8-0.1 c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.5C94,97.1,94,96.8,94,96.6c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.5 c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.5-0.1,0.8-0.1c0.2,0,0.4,0,0.5,0c0.1,0,0.3,0.1,0.4,0.1v-1.7H98.7z M96.3,96.9 c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.4-0.3-0.7-0.3c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.1,0.1-0.1,0.2 C95.9,96.7,96,96.9,96.3,96.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107.3,86.4c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3 h-1.5v6.4c0,0-0.1,0-0.3,0.1c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.1-0.1-0.1-0.3-0.1-0.5v-1.7c-0.2-0.4-0.4-0.7-0.7-0.9c-0.3-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0.1-0.6,0.2 c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.1-0.6,0.1 c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.4-0.3c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.3,0.1-0.6,0.2-0.9 c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.3,0.8-0.4c0.3-0.1,0.6-0.1,1-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0,0.4,0.1,0.5,0.2 c0.2,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.3,0.2v-1.7h-4.6c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6 c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3H107.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.5,83.3c0.6,0.3,1.1,0.3,1.5,0l0.2,0.2l-0.4,0.7l-1,0.4L85.5,83.3L85.5,83.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.2,85c-0.2-0.1-0.2-0.4-0.2-0.5c0-0.2,0.1-0.4,0.3-0.5l1.9-1.6c0.3-0.3,0.8-0.2,1,0.1 c0.3,0.3,0.2,0.8-0.1,1c-0.5,0.4-0.9,0.8-1.4,1.1c-0.6,0-0.9,0.2-1.2,0.3C86.5,84.9,86.4,85,86.2,85z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M84.3,84.5c1.6,0.6,2.9,0.8,3.6,0l-3.1-1.1l-1.5,0.7L84.3,84.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible",
      fill: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M82.3,86.4c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3 h-1.5v6.6c0,0-0.1,0-0.3,0.1c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.1-0.1-0.1-0.3-0.1-0.5v-5.8h-0.7c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6c0-0.1,0-0.3,0.1-0.4 c0-0.1,0.1-0.2,0.1-0.3h1.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.5-0.6,0.8-0.8 c0.3-0.2,0.7-0.4,1.2-0.5c0.5-0.1,0.9-0.2,1.5-0.2c0.4,0,0.9,0,1.3,0.1c0.4,0.1,0.8,0.2,1.1,0.3c0.3,0.1,0.6,0.2,0.8,0.3 c0.2,0.1,0.4,0.2,0.5,0.3c0.3,0.2,0.5,0.4,0.6,0.5c0.1,0.2,0.1,0.4,0.2,0.5c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.3,0.1 c-0.1,0-0.1,0-0.1,0c-0.2,0-0.4-0.1-0.6-0.1c-0.2-0.2-0.3-0.3-0.3-0.3l0,0c0,0-0.5-0.1-0.9-0.1c-0.6-0.1-0.5-0.2-1.1-0.3 c-0.5-0.1-0.9-0.1-1.1-0.1c-0.2,0-0.5,0-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.3-0.1,0.5 c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.1,0.3,0.2,0.3H82.3z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.5,86.3c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.1,0.3h-1.5 v6.6c0,0-0.1,0-0.3,0.1c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.1-0.1-0.1-0.3-0.1-0.5v-5.8h-0.7c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6c0-0.1,0-0.3,0.1-0.4 c0-0.1,0.1-0.2,0.1-0.3h1.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.4,0.1-0.8,0.3-1.1c0.2-0.3,0.5-0.6,0.8-0.8 c0.3-0.2,0.7-0.4,1.2-0.5c0.5-0.1,0.9-0.2,1.5-0.2c0.4,0,0.9,0,1.3,0.1c0.4,0.1,0.8,0.2,1.1,0.3c0.3,0.1,0.6,0.2,0.8,0.3 c0.2,0.1,0.4,0.2,0.5,0.3c0.3,0.2,0.5,0.4,0.6,0.5c0.1,0.1,0.2,0.4,0.2,0.5c-0.1,0.1-0.3,0.1-0.4,0c-0.1,0-0.2-0.1-0.3-0.1 c0,0-0.1,0-0.1,0c-0.2,0-0.3,0.3-0.3,0.3c-0.1,0-0.2,0-0.3,0c0,0-0.5-0.1-0.9-0.1c-0.6-0.1-0.5-0.2-1.1-0.3 c-0.5-0.1-0.9-0.1-1.1-0.1c-0.2,0-0.5,0-0.7,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.3-0.1,0.5 c0,0.2,0,0.4,0.1,0.5c0.1,0.1,0.1,0.3,0.2,0.3H82.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M87.8,84.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "87.5,84.4 88,83.9 88.1,84.4 87.7,84.8  "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M85.3,83.2c0.7,0.3,1.4,0.3,1.9,0l-0.3,0.9L85.3,83.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.2097,
    y1: 90.8289,
    x2: 63.9928,
    y2: 90.8289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#040F57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#D75CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C03249"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "56.2,94.2 63,87.5 61.1,89.7 64,94.2 61.1,94.2 59.6,91.4 58.8,92.3 58.8,94.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.3756,
    y1: 90.5634,
    x2: 73.0363,
    y2: 90.5634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C03249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4972,
    style: {
      stopColor: "#D75CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#9043C3"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73,94.1l-0.3-1.9c-0.5,0.1-0.7-0.1-0.7-0.6l0-2.4l-2.6-2.4l0,4.7C69.4,93.9,70.7,94.8,73,94.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.9467,
    y1: 92.615,
    x2: 77.6194,
    y2: 92.615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9134,
    style: {
      stopColor: "#040F57"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M74,90.9c-0.1,2.8,1,4,3.7,3.3L74,90.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.3437,
    y1: 84.8155,
    x2: 67.526,
    y2: 84.8155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD2B48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C03249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    style: {
      stopColor: "#E79556"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BD2B48"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M66.4,84.1l-1.1,1c0.7,0.5,1.6,0.5,2.2,0L66.4,84.1z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "87.9,84.6 88.6,83.9 87.6,83.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.9151,
    y1: 64.0407,
    x2: 70.8664,
    y2: 64.0407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD2B48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C03249"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    style: {
      stopColor: "#E79556"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BD2B48"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "60.9,61.9 62.1,61.4 67.7,59.4 70.9,68.2 69.6,68.6 69.4,68.2 70.2,67.9 67.3,60.2 61.7,62.2  62,62.9 61.4,63.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.39,
    y1: 70.0361,
    x2: 76.1779,
    y2: 70.0361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#040F57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2654,
    style: {
      stopColor: "#12348D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#9043C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7821,
    style: {
      stopColor: "#D75CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C03249"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M67.8,82.4c-0.8-1.5-5.3-5.2-7.5-5.3c-1.6-0.3-3-0.7-3.5-0.5c-0.4,0.2-1.5-0.5-1.5-1s0.4-1.1,0.4-1.4 s0-0.7-0.4-1.1c-0.4-0.3,0.1-1,0.1-1l0.1-0.1c0,0-0.4,0-0.6-0.2c-0.2-0.2-0.2-0.4,0-0.9s0.1-1.1-0.6-1.3s-1.2-0.7-0.7-1.3 c0.5-0.7,2.4-2.9,2.4-3.2c0-0.3,0.1-1.9,0.2-2c0.1-0.2,3.5-10.2,13.7-6.9c7.9,2.4,9,15.4,0.2,17c0,0-5.5,0.7-7.5-3.5 c-2-4.2-2.5-6.3-2.5-6.3l1.3-0.5l5.6-2l3.1,8.5l-0.6,0.3l-2.9-8l-5.6,2l2.2,5.8c3.3,4.2,8.8,2.4,10.3-0.3 c2-2.7,1.4-9.4-4.1-11.5c-5.7-2.1-10,1.5-11.3,5.9c0,0-1.4,6.9,5.5,9.5s5.1,11.4,5.1,11.4L67.8,82.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "63.1,69.4 63.3,69.6 63.2,69.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -773.5848,
    y1: -396.33,
    x2: -756.9346,
    y2: -418.8285,
    gradientTransform: "matrix(0.9619 0.2734 -0.2734 0.9619 678.3111 640.7599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07101E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4753,
    style: {
      stopColor: "#052D4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#021B30"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 53.6,
    cy: 39.5,
    r: 14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -774.7328,
    y1: -397.4091,
    x2: -758.0826,
    y2: -419.9077,
    gradientTransform: "matrix(0.9619 0.2734 -0.2734 0.9619 678.3111 640.7599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#083E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4908,
    style: {
      stopColor: "#083E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#085E9C"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 52.8,
    cy: 38.1,
    r: 14
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5706 -0.8212 0.8212 0.5706 -8.6318 59.7632)",
    className: "st20",
    cx: 52.8,
    cy: 38.1,
    rx: 12.8,
    ry: 12.8
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    className: "st21",
    d: "M49.9,43.2l2.2,0.6l1.6-5.6l1.6,0.4l0.7-1.8l-1.7-0.5c0,0,0.2-0.7,0.3-1.1 c0.1-0.4,0.3-0.6,0.7-0.5c0.3,0.1,1.2,0.3,1.2,0.3l0.6-1.9c0,0-1.3-0.4-1.5-0.4c-1.7-0.5-2.6,0-3,1.4c-0.3,1.2-0.4,1.5-0.4,1.5 l-1.2-0.3l-0.5,1.9l1.2,0.3L49.9,43.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.0683,
    y1: 117.2566,
    x2: 83.6993,
    y2: 103.0719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1B75BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3192"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 79.7,
    cy: 110.6,
    r: 10.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1190.1637,
    y1: 1417.4207,
    x2: 1202.9116,
    y2: 1400.1949,
    gradientTransform: "matrix(0.8678 -0.4969 0.4969 0.8678 -1659.9022 -517.7096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0044E9"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st23",
    cx: 78.5,
    cy: 110.3,
    r: 10.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.332 -0.9433 0.9433 0.332 -51.608 147.7114)",
    className: "st20",
    cx: 78.5,
    cy: 110.3,
    rx: 9.8,
    ry: 9.8
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M73.3,111.8l1.6-1.6l5.1,5.1l-1.6,1.6L73.3,111.8z M71.6,108.5c0.5-0.5,1.3-0.5,1.9,0 c0.5,0.5,0.5,1.3,0,1.9c-0.5,0.5-1.3,0.5-1.9,0C71,109.8,71,109,71.6,108.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M75.9,109.2l1.5-1.5l0.7,0.7l0,0c-0.2-0.6-0.1-1.6,0.7-2.3c1.6-1.6,3-0.9,4.4,0.5l2.8,2.8l-1.6,1.6 l-2.5-2.5c-0.6-0.6-1.4-1.4-2.2-0.5c-0.8,0.8-0.3,1.6,0.4,2.3l2.5,2.5l-1.6,1.6L75.9,109.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -4737.8159,
    y1: 1063.2799,
    x2: -4721.4355,
    y2: 1041.1458,
    gradientTransform: "matrix(-0.9149 0.4038 0.4038 0.9149 -4655.9326 1011.7801)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#250520"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4842,
    style: {
      stopColor: "#541239"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E153B"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 96.1,
    cy: 64.6,
    r: 13.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.7946,
    y1: 70.4131,
    x2: 85.3705,
    y2: 54.2305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDC100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5012,
    style: {
      stopColor: "#BB1832"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C2A86"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st25",
    cx: 96.7,
    cy: 63.2,
    r: 13.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9541 -0.2996 0.2996 0.9541 -14.4914 31.8657)",
    className: "st26",
    cx: 96.7,
    cy: 63.2,
    rx: 12.6,
    ry: 12.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_119_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    className: "st21",
    d: "M94.4,58c1.5-0.8,1.7-0.9,2.3-1.2c0.6-0.3,0.9-0.3,1.2-0.4c0.3,0,0.6,0,0.9,0.1 c0.3,0.1,0.5,0.2,0.8,0.4c0.2,0.2,0.4,0.4,0.8,0.9c0.3,0.6,0.4,0.8,1.3,2.3c0.8,1.5,0.9,1.7,1.2,2.3c0.3,0.6,0.3,0.9,0.4,1.2 c0,0.3,0,0.6-0.1,0.9c-0.1,0.3-0.2,0.5-0.4,0.8c-0.2,0.2-0.4,0.4-0.9,0.8c-0.6,0.3-0.8,0.4-2.3,1.3c-1.5,0.8-1.7,0.9-2.3,1.2 c-0.6,0.3-0.9,0.3-1.2,0.4c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.8-0.4c-0.2-0.2-0.4-0.4-0.8-0.9c-0.3-0.6-0.4-0.8-1.3-2.3 c-0.8-1.5-0.9-1.7-1.2-2.3c-0.3-0.6-0.3-0.9-0.4-1.2c0-0.3,0-0.6,0.1-0.9c0.1-0.3,0.2-0.5,0.4-0.8c0.2-0.2,0.4-0.4,0.9-0.8 C92.7,59,92.9,58.9,94.4,58 M93.9,57c-1.5,0.8-1.7,0.9-2.3,1.3c-0.6,0.3-0.9,0.7-1.2,1c-0.3,0.3-0.5,0.7-0.7,1.2 c-0.1,0.5-0.2,0.9-0.1,1.4c0.1,0.4,0.2,0.9,0.5,1.5c0.3,0.6,0.4,0.8,1.2,2.4c0.8,1.5,0.9,1.7,1.3,2.3c0.3,0.6,0.7,0.9,1,1.2 c0.3,0.3,0.7,0.5,1.2,0.7c0.5,0.1,0.9,0.2,1.4,0.1c0.4-0.1,0.9-0.2,1.5-0.5c0.6-0.3,0.8-0.4,2.4-1.2c1.5-0.8,1.7-0.9,2.3-1.3 c0.6-0.3,0.9-0.7,1.2-1c0.3-0.3,0.5-0.7,0.7-1.2c0.1-0.5,0.2-0.9,0.1-1.4c-0.1-0.4-0.2-0.9-0.5-1.5c-0.3-0.6-0.4-0.8-1.2-2.4 c-0.8-1.5-0.9-1.7-1.3-2.3c-0.3-0.6-0.7-0.9-1-1.2c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.1-0.9-0.2-1.4-0.1 c-0.4,0.1-0.9,0.2-1.5,0.5C95.6,56.1,95.4,56.2,93.9,57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    className: "st21",
    d: "M95.4,59.8c-1.6,0.9-2.2,2.9-1.4,4.5c0.9,1.6,2.9,2.2,4.5,1.4c1.6-0.9,2.2-2.9,1.3-4.5 C99,59.5,97,58.9,95.4,59.8 M97.9,64.6c-1,0.6-2.3,0.2-2.9-0.9c-0.6-1-0.2-2.3,0.9-2.9c1-0.6,2.3-0.2,2.9,0.9 C99.4,62.7,99,64,97.9,64.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st21",
    d: "M99,57.7c0.2,0.4,0.1,0.8-0.3,1c-0.4,0.2-0.8,0.1-1-0.3c-0.2-0.4-0.1-0.8,0.3-1 C98.3,57.2,98.8,57.3,99,57.7"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.5201,
    y1: 70.2904,
    x2: 46.2223,
    y2: 84.74
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00487E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5473,
    style: {
      stopColor: "#217FB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00487E"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M48.9,73.8c-1.8-5.2-7.5-7.9-12.7-6.1c-5.2,1.8-7.9,7.5-6.1,12.7c1.8,5.2,7.5,7.9,12.7,6.1 C48,84.7,50.7,79,48.9,73.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -3720.3088,
    y1: 5740.5405,
    x2: -3735.0806,
    y2: 5728.8359,
    gradientTransform: "matrix(-0.9967 -8.120000e-02 8.120000e-02 -0.9967 -4141.3188 5491.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#47C1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AB9"
    }
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st28",
    cx: 39,
    cy: 78.1,
    r: 10
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9924 -0.1234 0.1234 0.9924 -9.338 5.4072)",
    className: "st26",
    cx: 39,
    cy: 78.1,
    rx: 9.1,
    ry: 9.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    className: "st21",
    d: "M35.5,83.1c1.1,0.3,2.2,0.3,3.4-0.1c3.7-1.2,4.8-5,3.7-7.8c0.3-0.4,0.5-0.9,0.7-1.4 c-0.3,0.3-0.7,0.5-1,0.7c0.3-0.4,0.5-0.9,0.5-1.4c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5-0.3-1.1-0.3-1.7-0.2c-1.3,0.4-1.8,1.9-1.1,3.1 c-1.7,0.5-3.4,0.1-4.8-0.7c-0.2,1.1,0.4,2.2,1.5,2.5c-0.3,0.1-0.7,0.1-1,0c0.3,0.9,1.2,1.6,2.2,1.5c-0.3,0.2-0.6,0.3-0.9,0.3 c0.5,0.7,1.4,1,2.3,0.8C37.5,82.2,36.6,82.9,35.5,83.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M118.4,32.9l-3.9-7.7c-0.5-1-1.7-1.4-2.7-0.9l-7.7,3.9c-1,0.5-1.4,1.7-0.9,2.7l1.2,2.5l-2.5,2.8 c-0.1,0.1,0,0.3,0.2,0.3l3.7-0.3l1.2,2.5c0.5,1,1.7,1.4,2.7,0.9l7.7-3.9C118.5,35.1,118.9,33.9,118.4,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M111.4,28.5c-0.7,0.4-1.1,1.1-1.1,1.9c-0.5-0.6-1.4-0.7-2.1-0.4c-0.9,0.4-1.3,1.6-0.9,2.5 c1.1,2.4,5,1.9,5,1.9s2.6-3,1.7-5C113.5,28.5,112.3,28.1,111.4,28.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M26.5,59.1l2-8.4c0.2-1.1,1.3-1.7,2.4-1.5l8.4,2c1.1,0.2,1.7,1.3,1.5,2.4l-0.6,2.7l3.1,2.2 c0.1,0.1,0.1,0.3-0.1,0.4l-3.7,0.5L38.8,62c-0.2,1.1-1.3,1.7-2.4,1.5l-8.4-2C26.9,61.2,26.3,60.2,26.5,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M32.3,53.2c0.8,0.2,1.4,0.8,1.5,1.6c0.4-0.7,1.2-1,2-0.9c1,0.2,1.7,1.2,1.5,2.2c-0.5,2.6-4.4,3-4.4,3 s-3.3-2.3-2.8-4.5C30.3,53.6,31.3,53,32.3,53.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_24_",
    d: "M84.3,84.5c1.6,0.6,2.9,0.8,3.6,0l-3.1-1.1l-1.5,0.7L84.3,84.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_25_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_24_",
    style: {
      overflow: "visible"
    }
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/socialMedia.4d07e703643b0c028cc96b25ed6f3f37.svg";
export { ForwardRef as ReactComponent };